import type { ScheduleDataState } from "@/pages/human-resources/time-management/schedules/site-schedule/model/schedule-data/ScheduleDataState.ts";
import useDefinedContextValue from "@/shared/custom-hook/useDefinedContextValue.ts";
import { ScheduleDataStateContext } from "@/pages/human-resources/time-management/schedules/site-schedule/model/schedule-data/ScheduleDataStateProvider.tsx";

export default function useScheduleDataState(): ScheduleDataState {
  return useDefinedContextValue(ScheduleDataStateContext);
}
